import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/Resume";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"; // Fixed imports
import "./style.css";
import "./App.css";
import "./animations.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactGA from "react-ga";
import ScrollToTop from "./components/ScrollToTop";
import ScrollEffects from "./components/ScrollEffects";
import CommandPalette from "./components/CommandPalette";
import FloatingControls from "./components/FloatingControls";

function PageFade({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="page-fade" key={pathname}>
      {children}
    </div>
  );
}

ReactGA.initialize("G-KN1E14N8YK");

function App() {
  const [load, updateLoad] = useState(true); // Fixed function name typo

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <ScrollEffects />
        <CommandPalette />
        <FloatingControls />
        <Navbar />
        <ScrollToTop />
        <PageFade>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
        </Routes>
        </PageFade>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
